import React, { ReactNode } from 'react'
import { ShoesState } from 'src/types'
import { Box, Grid } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'
import { muiGrey } from 'src/style/muiTheme'
import { SurfaceDrawers } from './SurfaceDrawers'

type Props = {
  breadcrumbTrail: string
  drawerIndex: number
  state: ShoesState
  rearSurfaceId: string
  frontSurfaceId: string
  sideSurfaceId: string
  soleSurfaceId: string
  children: ReactNode
  //   dispatch: React.Dispatch<PartialShoesAction>
  handleDrawerIndex: (_: any, newValue: 0 | 1 | 2 | 3) => void
}

export const ShoesOrderPageTemplate: React.FC<Props> = ({
  children,
  breadcrumbTrail, // パンくず
  state,
  rearSurfaceId,
  frontSurfaceId,
  sideSurfaceId,
  soleSurfaceId,
  drawerIndex,
  handleDrawerIndex
}) => {
  const { t } = useLocale()
  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={7} zIndex={20} position={'sticky'} top={0}>
          <Box zIndex={20} position="sticky" top={0} width={'100%'}>
            <Box zIndex={20} px={1} py={1} display={'flex'} justifyContent={'space-between'} bgcolor={'#fff'}>
              <Box fontSize={'12px'} color={muiGrey}>
                {breadcrumbTrail}
              </Box>
              <Box fontWeight={'bold'} fontSize={'12px'} color={muiGrey}>
                {t.SELECTED_BASE_MODEL}：{state.baseModel?.productNumber}
              </Box>
            </Box>
            <SurfaceDrawers {...{ rearSurfaceId, frontSurfaceId, sideSurfaceId, soleSurfaceId, drawerIndex, handleDrawerIndex }} />
          </Box>
        </Grid>
        <Grid item xs={12} md={5} zIndex={10}>
          <Box py={1}>{children}</Box>
        </Grid>
      </Grid>
    </Box>
  )
}
